export const getPercent = (maxValue: number, valueToConvert: number) => {
  return (valueToConvert / maxValue) * 100;
};
